import React from "react";
import { Card, CardBody } from "reactstrap";
import ReactTable from "@dhn/components/molecules/data-table";
import SectionHeader from "@dhn/components/molecules/section-header";
import StatusBadge from "@dhn/components/molecules/status-badge";

const columns = [
  {
    Header: "Especialidad",
    accessor: "name",
  },
  {
    Header: "Estado",
    width: 130,
    className: "text-center",
    Cell: () => (
      <StatusBadge color="success" icon="fa-check-circle">
        Aprobada
      </StatusBadge>
    ),
  },
];

export default function ApprovedSpecialitiesTable({ specialities = [] }) {
  return (
    <Card className="mb-0">
      <CardBody>
        <SectionHeader
          compact
          icon="fa-graduation-cap"
          title="Especialidades aprobadas"
        />
        <ReactTable
          className="-striped -highlight"
          data={specialities}
          columns={columns}
          defaultPageSize={Math.max(specialities.length, 1)}
          minRows={1}
          showPagination={false}
          noDataText="Este médico no tiene especialidades aprobadas"
        />
        <small className="text-muted d-block mt-2">
          Las nuevas especialidades se solicitan desde Mis especialidades y deben
          ser aprobadas por administración.
        </small>
      </CardBody>
    </Card>
  );
}
